import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { UsersComponent } from './_components/users/users.component';
import { AuthGuardService as AuthGuard } from './_services/auth-guard.service';
import { UserEditComponent } from './_components/users/user-edit/user-edit.component';
import { DashboardComponent } from './_components/dashboard/dashboard.component';

import { ProgettoEditComponent } from './_components/progetti/progetto-edit/progetto-edit.component';
import { ProgettiComponent } from './_components/progetti/progetti.component';
import { OpportunityEditComponent } from './_components/opportunities/opportunity-edit/opportunity-edit.component';
import { OpportunitiesComponent } from './_components/opportunities/opportunities.component';
import { ModelPdfComponent } from './_components/model/model-pdf/model-pdf.component';
import { DoctemplatesComponent } from './_components/doctemplates/doctemplates.component';
import { DoctemplateEditComponent } from './_components/doctemplates/doctemplate-edit/doctemplate-edit.component';
import { TicketsComponent } from './_components/tickets/tickets.component';
import { TicketEditComponent } from './_components/tickets/ticket-edit/ticket-edit.component';
import { TranslationsComponent } from './_components/translations/translations.component';


const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled'
};

const routes: Routes = [
    {
        path: '', component: AppLayoutComponent,
        children: [
            {path: '', loadChildren: () => import('./_components/auth/login/login.module').then(m => m.LoginModule) },
            {path: 'login', loadChildren: () => import('./_components/auth/login/login.module').then(m => m.LoginModule) },
            {path: 'login/:lang', loadChildren: () => import('./_components/auth/login/login.module').then(m => m.LoginModule) },
            {path: 'dashboard',data: { breadcrumb: 'Preventivatore' }, component: DashboardComponent, canActivate: [AuthGuard] },
      
            
            {path: 'doctemplates',data: { breadcrumb: 'Modelli' }, component: DoctemplatesComponent, canActivate: [AuthGuard] },
            {path: 'doctemplates/doctemplate-edit/:action',data: { breadcrumb: 'Nuovo modello' }, component: DoctemplateEditComponent, canActivate: [AuthGuard] },
            {path: 'doctemplates/doctemplate-edit/:action/:id',data: { breadcrumb: 'Modifica modello' }, component: DoctemplateEditComponent, canActivate: [AuthGuard] },
         
            {path: 'users',data: { breadcrumb: 'Utenti' }, component: UsersComponent, canActivate: [AuthGuard] },
            {path: 'users/user-edit/:action',data: { breadcrumb: 'Nuovo utente' }, component: UserEditComponent, canActivate: [AuthGuard] },
            {path: 'users/user-edit/:action/:id',data: { breadcrumb: 'Modifica utente' }, component: UserEditComponent, canActivate: [AuthGuard] },
         
            { path: 'accounts', redirectTo: '/opportunities', pathMatch: 'prefix' },

            {path: 'tickets',data: { breadcrumb: 'Tickets' }, component: TicketsComponent, canActivate: [AuthGuard] },
            {path: 'tickets/ticket-edit/:action',data: { breadcrumb: 'Nuovo ticket' }, component: TicketEditComponent, canActivate: [AuthGuard] },
            {path: 'tickets/ticket-edit/:action/:id',data: { breadcrumb: 'Modifica ticket' }, component: TicketEditComponent, canActivate: [AuthGuard] },

            {path: 'translations',data: { breadcrumb: 'Traduzioni' }, component: TranslationsComponent, canActivate: [AuthGuard] },
       
            {path: 'opportunities/opportunity-edit/:action',data: { breadcrumb: 'Nuovo preventivo' }, component: OpportunityEditComponent, canActivate: [AuthGuard] },
           
            {path: 'opportunities/opportunity-edit/:action/:id',data: { breadcrumb: 'Modifica preventivo' }, component: OpportunityEditComponent, canActivate: [AuthGuard] },
           
            
            {path: 'opportunities-account/:id',data: { breadcrumb: 'Elenco preventivi' }, component: OpportunitiesComponent, canActivate: [AuthGuard] },
   
            {path: 'opportunities',data: { breadcrumb: 'Elenco preventivi' }, component: OpportunitiesComponent, canActivate: [AuthGuard] },
   
            
            {path: 'projects',data: { breadcrumb: 'Progetti' }, component: ProgettiComponent, canActivate: [AuthGuard] },
            {path: 'projects/projects-edit/:action',data: { breadcrumb: 'Nuovo Progetto' }, component: ProgettoEditComponent, canActivate: [AuthGuard] },
            {path: 'projects/projects-edit/:action/:id',data: { breadcrumb: 'Modifica Progetto' }, component: ProgettoEditComponent, canActivate: [AuthGuard] },
           
         
            {path: 'model-pdf', component: ModelPdfComponent, canActivate: [AuthGuard] },
          
         
                

        ]
    }
   
];

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
